import { React, useRef, useEffect, useState } from 'react';
import axios from 'axios';
import ClearIcon from '@mui/icons-material/Clear';
import TokenService from '../../services/TokenService'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import AlertDialog from '../Modals/AlertDialog'
import IconButton from '@mui/material/IconButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import styles from './DriverSignupWizard.module.css'; // Import css modules stylesheet as styles
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSnackbar } from 'notistack';

const DriverForm = (props) => {
    const [snackbar, setSnackbar] = useState({
        message: '',
        severity: 'info'
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [emailAddress2, setEmailAddress2] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const prevCustomerPhoneNumber = useRef();
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [agreeInMichigan, setAgreeInMichigan] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [formValidation, setFormValidation] = useState({
        isValid: false,
        errors: []
    });

    const ipAddressRef = useRef('');

    useEffect(() => {
        //assign the ref's current value to the count Hook
        prevCustomerPhoneNumber.current = phoneNumber;
    }, [phoneNumber]); //run this code when the value of customerPhoneNumber changes

    getIPAddress();

    function validate() {

        let isValid = true;
        let errors = [];

        if (firstName.trim() == '') {
            errors["Firstname"] = "Missing your First Name";
            isValid = false;
        }

        if (lastName.trim() == '') {
            errors["Lastname"] = "Missing your Last Name";
            isValid = false;
        }

        if (emailAddress.trim() === '') {
            errors["EmailAddress"] = "Missing your Email";
            isValid = false;
        }
        else {
            if (!isValidEmail(emailAddress.trim())) {
                isValid = false;
                errors["EmailAddress"] = "Not a valid email.";

            }
            else {
                if (emailAddress.trim().toLowerCase().indexOf('@gmail.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@gmail.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @gmail.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@yahoo.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@yahoo.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @yahoo.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@hotmail.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@hotmail.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @hotmail.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@aol.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@aol.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @aol.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@comcast.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@comcast.net') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @comcast.net?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@sbcglobal.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@sbcglobal.net') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @sbcglobal.net?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@icloud.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@icloud.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @icloud.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@outlook.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@outlook.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @outlook.com?";
                }
                else if (emailAddress.trim().toLowerCase().indexOf('@msn.') > -1 &&
                    emailAddress.trim().toLowerCase().indexOf('@msn.com') == -1) {
                    isValid = false;
                    errors["EmailAddress"] = "Did you mean @msn.com?";
                }

            }
        }

        if (emailAddress2.trim() === '') {
            errors["EmailAddress2"] = "Please re-enter your email";
            isValid = false;
        }

        if (emailAddress.trim() !== '' && emailAddress2.trim() !== '') {
            if (emailAddress.trim().toUpperCase() !== emailAddress2.trim().toUpperCase()) {
                errors["EmailAddress2"] = "Emails do not match";
                isValid = false;
            }
        }

        if (phoneNumber.trim() === '') {
            errors["PhoneNumber"] = "Please enter your phone number";
            isValid = false;
        }
        else if (phoneNumber.trim().length !== 14) {
            errors["PhoneNumber"] = "Enter your 10 digit phone number";
            isValid = false;
        }

        if (typeof dateOfBirth === 'string' && dateOfBirth.trim() === '') {
            errors["DateOfBirth"] = "Please enter your date of birth";
            isValid = false;
        }
        else if (dateOfBirth.toString() == 'Invalid Date') {
            errors["DateOfBirth"] = "Not a valid date. use MM/DD/YYYY";
            isValid = false;
        }
        else if (getAge(dateOfBirth.toString()) < 16) {
            errors["DateOfBirth"] = "Our minimum age is 16 (with Parental Consent)";
            isValid = false;
        }

        if (password.trim() === '') {
            errors["Password"] = "Missing your Password";
            isValid = false;
        }
        else if (password2.trim() != password.trim()) {
            errors["Password2"] = "Passwords do not match";
            isValid = false;
        }

        if (!agreeToTerms) {
            errors["AgreeToTerms"] = "You must agree to Sipzee's Terms of Use";
            isValid = false;
        }

        if (!agreeInMichigan) {
            errors["AgreeInMichigan"] = "You must reside in Michigan, USA to use Sipzee";
            isValid = false;
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    function getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    function setPhoneNumberChanged(val) {
        let phone = normalizePhoneNumber(val, prevCustomerPhoneNumber.current);
        setPhoneNumber(phone);
    }

    function normalizePhoneNumber(value, previousValue) {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        //if (!previousValue)// || value.length > previousValue.length)
        {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    function getIPAddress() {
        axios
            .get("https://api.ipify.org")
            .then(function (response) {
                console.log(response);
                ipAddressRef.current = response;
            });
    }

    function finalValidation() {
        let validated = validate();

        if (validated.isValid) {
            setIsLoading(true);
            //TokenService
            let postData = {
                FirstName: firstName,
                LastName: lastName,
                EmailAddress: emailAddress,
                PhoneNum: phoneNumber,
                Password: password,
                DOB: dateOfBirth.format('MM/DD/YYYY'),
                ipAddress : getIPAddress()
            }
           
            TokenService.postRecycler(postData, 'CreateReturnerAccount', '')
                .then((response) => {
                    if (response !== null) {
                        setIsLoading(false);
                        response = response[Object.keys(response)[0]];
                        if (response.Result === "SUCCESS") {
                            //let jsonData = JSON.parse(response.JsonData);

                            props.Next();
                        }
                        else if (response.Result === "FAIL") {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    }
                })
                .catch((response) => {
                    if (response !== null) {
                        if (response.Result === "FAIL") {

                        }

                    }
                });
            
        }
        
    }
    if (isLoading) {

        return
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="50px"
        >
            <CircularProgress color="secondary" />
        </Box>
    }
    else {
        return (
            <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>

                <div className={styles.cardHeader}>Driver Sign Up</div>

                <div className={styles.ContactSection}>
                    <div className={styles.ContactSectionHeader}>
                        <span>Name</span>

                    </div>
                    <div className={styles.ContactSectionBody}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['Firstname'] !== undefined} label="First Name" onChange={(e) => setFirstName(e.target.value)} value={firstName} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Firstname'] !== undefined ? formValidation.errors['Firstname'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['Lastname'] !== undefined} label="Last Name" onChange={(e) => setLastName(e.target.value)} value={lastName} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Lastname'] !== undefined ? formValidation.errors['Lastname'] : ''}</div>
                    </div>

                    <div className={styles.ContactSectionHeader} style={{ marginTop: '10px' }}>
                        <span>Contact Info</span>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['EmailAddress'] !== undefined} label="Email" onChange={(e) => setEmailAddress(e.target.value)} value={emailAddress} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['EmailAddress'] !== undefined ? formValidation.errors['EmailAddress'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['EmailAddress2'] !== undefined} label="Re-enter Email" onChange={(e) => setEmailAddress2(e.target.value)} value={emailAddress2} variant="outlined" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['EmailAddress2'] !== undefined ? formValidation.errors['EmailAddress2'] : ''}</div>
                    </div>

                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['PhoneNumber'] !== undefined} label="Phone Number" onChange={(e) => setPhoneNumberChanged(e.target.value)} value={phoneNumber} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['PhoneNumber'] !== undefined ? formValidation.errors['PhoneNumber'] : ''}</div>
                    </div>

                    <div className={styles.ContactSectionHeader} style={{ marginTop: '10px' }}>
                        <span>Age Verification</span>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date of Birth"
                                value={dateOfBirth}
                                onChange={(newValue) => {
                                    setDateOfBirth(newValue);
                                }}
                                disableFuture
                                renderInput={(params) => (
                                    <TextField {...params} />
                                )}
                            />
                        </LocalizationProvider>
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['DateOfBirth'] !== undefined ? formValidation.errors['DateOfBirth'] : ''}</div>
                    </div>

                    <div className={styles.ContactSectionHeader} style={{ marginTop: '10px' }}>
                        <span>Password Setup</span>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['Password'] !== undefined} label="Choose a Password" onChange={(e) => setPassword(e.target.value)} value={password} variant="outlined" type="password" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Password'] !== undefined ? formValidation.errors['Password'] : ''}</div>
                    </div>
                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <TextField className={styles.ContactSectionText} error={formValidation.errors['Password2'] !== undefined} label="Re-enter Password" onChange={(e) => setPassword2(e.target.value)} value={password2} variant="outlined" type="password" />
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Password2'] !== undefined ? formValidation.errors['Password2'] : ''}</div>
                    </div>

                    <div className={styles.ContactSectionBody} style={{ marginTop: '15px' }}>
                        <div style={{ display: 'flex', marginLeft: '5px' }}>

                            <StyledCheckbox style={{ marginTop: '-15px' }} checked={agreeToTerms} onChange={(e) => setAgreeToTerms(e.target.checked)} />
                            <div>
                                I Agree to the <a target='_blank' href='https://sipzee.com/terms-of-service.aspx'>Terms of Use</a>?
                            </div>

                        </div>
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['AgreeToTerms'] !== undefined ? formValidation.errors['AgreeToTerms'] : ''}</div>
                    </div>

                    <div className={styles.ContactSectionBody} style={{ marginTop: '7px' }}>
                        <div style={{ display: 'flex', marginLeft: '5px' }}>

                            <StyledCheckbox style={{ marginTop: '-15px' }} checked={agreeInMichigan} onChange={(e) => setAgreeInMichigan(e.target.checked)} />
                            <div>
                                I live in Michigan
                            </div>

                        </div>
                        <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['AgreeInMichigan'] !== undefined ? formValidation.errors['AgreeInMichigan'] : ''}</div>
                    </div>


                    <Button style={{ marginTop: '15px', alignSelf: 'center' }} variant='contained' color="sipzeeGreen" onClick={() => finalValidation()}>Create Account</Button>

                </div>



            </div>
        )
    }

}

export default DriverForm;